<template>
  <Panel>
    <template slot="panel">
      <Breadcrumb :routes="routes"></Breadcrumb>
      <Title :title="$root.language.technologyRow6"></Title>
      <p class="font-20">
        {{$root.language.technologyRow7}}
      </p>
      <p class="font-16">
        <a-icon type="caret-right" :style="iconColor" />
      </p>
    </template>
  </Panel>
</template>

<script>
import Panel from '@/components/panel'
import Breadcrumb from '@/components/breadcrumb'
import Title from '@/components/title'
export default {
  components: {
    Panel,
    Breadcrumb,
    Title
  },

  data () {
    return {
      routes: [{
        name: this.$root.language.jwisoftware,
        path: '/'
      },
      {
        name: this.$root.language.technology,
        path: '/technology'
      },
      {
        name: this.$root.language.twin,
        path: '/technology/twin'
      }
      ],
      iconColor: {
        color: '#DA4026'
      }
    }
  }
}

</script>
